import React from "react";
import { Link } from "@quintype/components";
import { object, string } from "prop-types";

import BigSectionName from "../../atoms/BigSectionName";
import SubSectionsMenuItems from "../../atoms/SubSectionsMenuItems";

import "./sectionMenuDom.m.css";

const SectionMenuDom = ({
  domainSectionObj,
  domainSlug,
  sectionsDataForHeader,
  sectionMenuItem,
  language,
  multiDomainWrapperName,
}) => {
  return (
    <nav styleName={`navbar ${multiDomainWrapperName ? `nav-${multiDomainWrapperName}` : ""}`} className="navbar">
      <ul styleName="parent-section">
        <BigSectionName
          domainSectionObj={domainSectionObj}
          domainSlug={domainSlug}
          sectionsDataForHeader={sectionsDataForHeader}
        />
      </ul>
      {sectionMenuItem && sectionMenuItem.children.length > 0 ? (
        <ul styleName="sub-sections" className="sub-sections">
          {sectionMenuItem.children.slice(0, 12).map((item, index) => (
            <li
              styleName={`child-section ${language === "en" ? "en-child-section" : ""}`}
              className={` ${item.title} child-section ${
                sectionsDataForHeader.currentSectionUrl === item.completeUrl ? "current-section" : ""
              }`}
              key={index}
            >
              {item.completeUrl === "/#" ? (
                <span>{item.title}</span>
              ) : (
                <Link href={item.completeUrl}>{item.title}</Link>
              )}
            </li>
          ))}
        </ul>
      ) : (
        <SubSectionsMenuItems sectionsDataForHeader={sectionsDataForHeader} language={language} />
      )}
    </nav>
  );
};

SectionMenuDom.propTypes = {
  domainSectionObj: object,
  domainSlug: string,
  sectionsDataForHeader: object,
  sectionMenuItem: object,
  language: string,
  multiDomainWrapperName: string,
};

export default SectionMenuDom;
